/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountDetailsWarningMessage.scss';
import React from 'react';

const AccountDetailsWarningMessage = ({
  message,
}) => {

  return (
    <div className="account-details-warning-content">
      <p>{message}</p>
    </div>
  );
}

export default AccountDetailsWarningMessage;
